export const DEFAULT_SETTINGS_SETUP = {
  GLOBAL: 'GLOBAL',
  SELECT_COMPANY: 'SELECT_COMPANY',
}
